
import { FederatedModule } from '@bfme-technology/spa';
import { getResolvedMfeProps } from '../Dashboard.utils';



import type { ChartingMfeProps } from './ChartingMfe.types';

export const ChartingMfe: React.FC<ChartingMfeProps> = ({ routesLoading, routes }) => {
  return (
    <section className="glass-panel p-5 md:p-6 flex flex-col gap-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div>
          <h3 className="text-base md:text-lg font-bold text-text-primary">Wealth Analytics Trends</h3>
          <span className="text-xs text-text-muted">Net growth and analytics projection (H1 2026)</span>
        </div>
      </div>

      {(() => {
        if (routesLoading) {
          return <div className="text-text-muted text-xs py-10 text-center">Loading Chart MFE...</div>;
        }
        const route = routes.find((r) => r.key === 'mfe-charting');
        if (!route) {
          return <div className="text-red-500 text-xs py-10 text-center">Chart MFE configuration not found.</div>;
        }
        const resolved: any = getResolvedMfeProps(route);
        const { key, ...mfeProps } = resolved;
        return <FederatedModule {...mfeProps} />;
      })()}
    </section>
  );
};
